import { usePlatformStore } from "@/entities/platform";
import axios from "axios";

const api = axios.create({
  baseURL: "https://test.customer.api.delever.uz",
  timeout: 10000,
  headers: {
    Shipper: process.env.NEXT_PUBLIC_SHIPPER_ID,
    Platform: process.env.NEXT_PUBLIC_PLATFORM_ID,
  },
});

api.interceptors.request.use((config) => {
  const { params } = usePlatformStore.getState();
  const token =
    params?.token ||
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIxNDcxNjgyNjAsImlhdCI6MTc2ODQ3NzA2MCwiaXNzIjoiYWdncmVnYXRvci1zaGlwcGVyIiwic2hpcHBlcl9pZCI6IjcyMmRmYzljLWU1YjItNDFmYy04ZTQ1LTU1NzhiOTkwY2Q1OCIsInVzZXJfdHlwZV9pZCI6ImJiNjAzZTllLTQ5YTMtNDc4Yi05ZTEwLWM3ODQyZjljNjc2ZiIsInN1YiI6IjcyMmRmYzljLWU1YjItNDFmYy04ZTQ1LTU1NzhiOTkwY2Q1OCJ9.KpbWZYr6KrIT_CHWXO6T1hjGGrOhITpxTc3VJMVpRJg";

  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
